import { render } from "./course-multiple-lookup.vue?vue&type=template&id=38ffebe5"
import script from "./course-multiple-lookup.vue?vue&type=script&setup=true&lang=js"
export * from "./course-multiple-lookup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/shared/components/lookup/course-multiple-lookup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38ffebe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38ffebe5', __exports__)) {
    api.reload('38ffebe5', __exports__)
  }
  
  module.hot.accept("./course-multiple-lookup.vue?vue&type=template&id=38ffebe5", () => {
    api.rerender('38ffebe5', render)
  })

}


export default __exports__